import { getLiquidEngine } from "../services/liquid.service";
import { toProductVariantGid } from "../services/product.service";
import { storefrontApiRequest } from "../services/shopify.service";
import productColorDisplayValueTemplate from '../../snippets/product-color-display-value.liquid';
export async function fetchAdditionalProductVariantInfo(variantIds, options) {
    const gids = variantIds.map(toProductVariantGid);
    const query = `
    query getProductVariants($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on ProductVariant {
          id
          availableForSale
          selectedOptions {
            name
            value
          }
          product {
            id
            compareAtPriceRange {
                minVariantPrice {
                amount
              }
            }
            tags
          }
        }
      }
    }
  `;
    const res = await storefrontApiRequest(query, { ids: gids });
    const output = res.data.nodes.filter(n => !!n).reduce((acc, curr) => {
        const idArr = curr.id.split("/");
        const key = idArr[idArr.length - 1];
        const colorDisplayValue = (getLiquidEngine().parseAndRenderSync(productColorDisplayValueTemplate, { _product: curr.product }) || '').trim();
        let badgingText = null;
        const badgeTag = curr.product.tags.find(t => t.startsWith(options.badgePrefix));
        const badgeTextArr = badgeTag ? badgeTag.split(":") : null;
        if (badgeTextArr && window.UNTUCKitConfig?.showProductBadging) {
            badgingText = badgeTextArr[badgeTextArr.length - 1]; // sometimes the ecomm team uses :: (e.g. badge-pdp::)
        }
        const compareAtPrice = +curr.product.compareAtPriceRange.minVariantPrice.amount * 100;
        acc[key] = {
            availableForSale: curr.availableForSale,
            colorDisplayValue: colorDisplayValue,
            compareAtPrice: compareAtPrice,
            badgingText: badgingText,
            selectedOptions: curr.selectedOptions
        };
        return acc;
    }, {});
    return output;
}
export function createCartLineItem(cartLineItem, config) {
    const el = document.createElement('cart-line-item');
    el.setAttribute('cart-line-item-data', JSON.stringify(cartLineItem));
    if (config.showQuantity !== undefined) {
        el.setAttribute('show-quantity', `${config.showQuantity}`);
    }
    if (config.lineNumber) {
        el.setAttribute("line-number", `${config.lineNumber}`);
    }
    el.setAttribute('actions-type', config.actionsType);
    let badgingText = cartLineItem.badgingText || '';
    // override badgingText in cart if discount code has been applied
    // this avoids awkward messaging if the discount code has already been applied (e.g. "30% off with code XYZ")
    if (['inline-cart', 'add-to-cart-overlay'].includes(config.actionsType) && cartLineItem.line_level_discount_allocations?.length) {
        const discountCodeAppliedMessaging = cartLineItem.line_level_discount_allocations
            .filter(llda => llda.amount > 0 && llda.discount_application.type === 'discount_code') // discounts can be 0 when applied via script editor
            // TODO: figure out how to handle amount off/percentage off
            .map(llda => {
            const da = llda.discount_application;
            switch (da.type) {
                case 'discount_code':
                    return `${da.title} applied`;
                default:
                    return da.title;
            }
        }).join('<br/>');
        if (discountCodeAppliedMessaging) {
            badgingText = discountCodeAppliedMessaging;
        }
    }
    el.setAttribute('badge-text', badgingText);
    el.setAttribute('compare-at-price', `${cartLineItem.compareAtPrice}`);
    el.setAttribute("color-display-value", cartLineItem.colorDisplayValue || '');
    if (cartLineItem.availableForSale !== undefined) {
        el.setAttribute("is-available", `${cartLineItem.availableForSale}`);
    }
    el.classList.add(config.styleClass);
    return el;
}
